const handleOfferBtn = () => {
  const cityItems = [...document.querySelectorAll('.city-card')];
  const map = document.querySelector('.page-kontakt__map-img');
  const btnLink = document.querySelector('.address__btn');
  const addressFirst = document.querySelector('.address__part-1');
  const addressSecond = document.querySelector('.address__part-2');
  // const map = document.querySelector('.page-kontakt__map');
  const itemsDims = [];

  if (cityItems) {
    cityItems.forEach((item, index) => {
      const itemHeight = item.clientHeight;
      const titleElem = item.querySelector('.city-card__wrapper');
      const arrow = item.querySelector('.city-card__btn');
      const descHeight = itemHeight - titleElem.clientHeight;

      itemsDims.push({
        itemHeight,
        titleHeight: titleElem.clientHeight,
        descHeight,
      });

      item.style.height = `${itemHeight - descHeight}px`;

      //Set first City active
      cityItems[0].style.height = `${itemHeight}px`;
      const firstArrow = cityItems[0].querySelector('.city-card__btn');
      firstArrow.style.transform = 'rotate(45deg)';

      item.addEventListener('click', function () {
        if (!this.classList.contains('city-card--active')) {
          if (this.style.height === `${itemHeight - descHeight}px`) {
            // closingAllcityItems
            cityItems.forEach((item, index) => {
              const {
                itemHeight: savedItemHeight,
                descHeight: savedDescHeight,
              } = itemsDims[index];

              const arrow = item.querySelector('.city-card__btn');
              item.style.height = `${savedItemHeight - savedDescHeight}px`;
              arrow.style.transform = 'rotate(0)';
              item.classList.remove('city-card--active');
            });
            arrow.style.transform = 'rotate(45deg)';
            this.style.height = `${itemHeight}px`;
            this.classList.add('city-card--active');

            // Dynamic Change map
            // map.innerHTML = window.maps[index].map;

            // Static Change map
            map.src = window.maps[index].img.url ?? '';
            addressFirst.textContent = window.maps[index].address ?? '';
            addressSecond.textContent = window.maps[index].address2 ?? '';
            btnLink.href = window.maps[index].map.url ?? '';
            btnLink.textContent = window.maps[index].map.title ?? '';
            btnLink.setAttribute('target', window.maps[index].map.target ?? '');
          } else {
            this.style.height = `${itemHeight - descHeight}px`;
            arrow.style.transform = 'rotate(0)';
          }
        }
      });
    });
  }
};
export default handleOfferBtn;
